import { render, staticRenderFns } from "./mcy-table.vue?vue&type=template&id=5233d7d7&scoped=true"
import script from "./mcy-table.vue?vue&type=script&lang=ts"
export * from "./mcy-table.vue?vue&type=script&lang=ts"
import style0 from "./mcy-table.vue?vue&type=style&index=0&id=5233d7d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233d7d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5233d7d7')) {
      api.createRecord('5233d7d7', component.options)
    } else {
      api.reload('5233d7d7', component.options)
    }
    module.hot.accept("./mcy-table.vue?vue&type=template&id=5233d7d7&scoped=true", function () {
      api.rerender('5233d7d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtc-step/mcy-table/mcy-table.vue"
export default component.exports